{
  "open": "Abrir chat",
  "unread_one": "{count} mensaje sin leer",
  "unread_many": "{count} de mensajes sin leer",
  "unread_other": "{count} mensajes sin leer",
  "close": "Cerrar"
}
